import React, { Component, PropTypes } from 'react';
import FormFieldRow from './FormFieldRow';
import './TableFormFields.scss';

class TableFormFields extends Component {
    render() {
        const { fieldsData, isDisabled } = this.props;

        if (fieldsData.length === 0) {
            return null;
        }

        return (
            <table className="table-form-fields">
                <thead>
                    <tr>
                        <th>
                            <h4>FORM FIELD</h4>
                        </th>
                        <th>
                            <h4>Quick Sign Up Form</h4>
                            <div>
                                <span>Display</span>
                                <span>Required/optional</span>
                            </div>
                        </th>
                        <th>
                            <h4>Create a Profile Form</h4>
                            <div>
                                <span>Display</span>
                                <span>Required/optional</span>
                            </div>
                        </th>
                        <th>
                            <h4>Guest Details</h4>
                            <div>
                                <span>Display</span>
                                <span>Required/optional</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {fieldsData.map(fieldData => (
                        <FormFieldRow
                            key={fieldData.code}
                            code={fieldData.code}
                            name={fieldData.name}
                            isDisabled={isDisabled}
                            showquickSignUp={fieldData.visibility[0]}
                            showcreateProfile={fieldData.visibility[1]}
                            showguestDetails={fieldData.visibility[2]}
                        />
                    ))}
                </tbody>
            </table>
        );
    }
}

TableFormFields.defaultProps = {
    fieldsData: []
};

TableFormFields.propTypes = {
    fieldsData: PropTypes.arrayOf(
        PropTypes.shape({
            code: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            visibility: PropTypes.arrayOf(PropTypes.bool).isRequired
        })
    ).isRequired,
    isDisabled: PropTypes.bool.isRequired
};

export default TableFormFields;



// WEBPACK FOOTER //
// ./src/components/widgets/TableFormFields/index.js